import React from "react";
import classNames from "classnames";

const Pulse = ({ className }) => (
  <div
    className={classNames(
      "rounded-2xl bg-white/90 dark:bg-gray-800/80 animate-pulse",
      className
    )}
  />
);

const CustomerMobilePageLoader = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="flex flex-col gap-2.5 py-2" aria-hidden>
        <Pulse className="h-16" />
        <Pulse className="h-16" />
        <Pulse className="h-16" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 py-1" aria-hidden>
      <Pulse className="h-7 w-2/3 rounded-lg" />
      <Pulse className="h-4 w-1/2 rounded-lg" />
      <Pulse className="h-36" />
      <Pulse className="h-24" />
      <div className="grid grid-cols-2 gap-2.5">
        <Pulse className="h-[108px]" />
        <Pulse className="h-[108px]" />
        <Pulse className="h-[108px]" />
        <Pulse className="h-[108px]" />
      </div>
    </div>
  );
};

export default CustomerMobilePageLoader;
